<template>
  <div class="profilo mobile_customize">
    <div class="box" v-loading="loading" :style="{ height: (contenitoreHeight - 20) + 'px' }">
      <div class="col-24 profilo-title">
        <span>{{ $t('profilo.titolo').toUpperCase() }}</span>
      </div>
      <div class="profilo-form">

        <!-- SEZIONE MODIFICA E-MAIL -->
        <div class="el-form_mobile" v-if="tabActive === '1'">
          <el-form class="el-form-body">

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.mail') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="input-wrapper">
                  <input v-model="mailForm.mail" class="first" />
                </div>
              </div>
            </div>

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.password') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="input-wrapper">
                  <input v-model="mailForm.pwd" class="first" type="password" />
                </div>
              </div>
            </div>
          </el-form>

          <span slot="footer" class="">
            <el-button class="mobile-el-button primary" @click="changeMail" :loading="loadingBtnMail">{{
              $t('profilo.btn.salva')
              }}</el-button>
          </span>

        </div>

        <!-- SEZIONE MODIFICA DOMANDA SEGRETA -->
        <div class="el-form_mobile" v-if="tabActive === '2'">
          <el-form class="el-form-body">

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.domanda') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="select-wrapper">
                  <select v-model="questionForm.question">
                    <option v-for="(item) in secretQuestions" :value="item.value" :key="item.value">{{
                      $t('questions.'+item.value) }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.risposta') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="input-wrapper">
                  <input v-model="questionForm.answer" class="first" type="password" />
                </div>
              </div>
            </div>

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.password') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="input-wrapper">
                  <input v-model="questionForm.pwd" class="first" type="password" />
                </div>
              </div>
            </div>
          </el-form>

          <span slot="footer" class="">
            <el-button class="mobile-el-button primary" @click="changeQuest" :loading="loadingBtnQuest">{{
              $t('profilo.btn.salva')
              }}</el-button>
          </span>

        </div>

        <!-- SEZIONE MODIFICA PASSWORD -->
        <div class="el-form_mobile" v-if="tabActive === '3'">
          <el-form class="el-form-body">

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.passwordOld') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="input-wrapper">
                  <input v-model="pwdForm.oldPwd" class="first" type="password" />
                </div>
              </div>
            </div>

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.passwordNew') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="input-wrapper">
                  <input v-model="pwdForm.newPwd" class="first" type="password" />
                </div>
              </div>
            </div>

            <div class="elemento row row-custom">
              <div class="el-form-label col-24 no-padding">{{ $t('profilo.passwordRep') }}</div>
              <div class="el-form-input col-24 no-padding">
                <div class="input-wrapper">
                  <input v-model="pwdForm.newPwdRep" class="first" type="password" />
                </div>
              </div>
            </div>
          </el-form>

          <span slot="footer" class="">
            <el-button class="mobile-el-button primary" @click="changePwd" :loading="loadingBtnPwd">{{
              $t('profilo.btn.salva')
              }}</el-button>
          </span>

        </div>

      </div>
    </div>


    <div class="menu-profilo">
      <div class="action" @click="openTab('1')" :class="tabActive === '1' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon counter-nuovi">
            <icon name="riv-messClsd" scale="2"></icon>
          </div>
          <span> {{ $t('profilo.mail').toUpperCase() }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('2')" :class="tabActive === '2' ? 'selected' : ''">
        <div class="box border-r">
          <div class="boxIcon">
            <icon name="riv-help" scale="2"></icon>
          </div>
          <span>{{ $t('profilo.domanda').toUpperCase() }}</span>
        </div>
      </div>
      <div class="action" @click="openTab('3')" :class="tabActive === '3' ? 'selected' : ''">
        <div class="box">
          <div class="boxIcon counter-bacheca">
            <icon name="riv-password" scale="2"></icon>
          </div>
          <span>{{ $t('profilo.password').toUpperCase() }}</span>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  components: {},
  name: 'ProfiloMobile',
  props: ['contenitoreHeight', 'userProfile'],
  i18n: {
    messages: {
      it_IT: {
        profilo: {
          titolo: 'Profilo Personale',
          domanda: 'Domanda Segreta',
          risposta: 'Risposta Segreta',
          password: 'Password',
          mail: 'e-mail',
          passwordOld: 'Vecchia Password',
          passwordNew: 'Nuova Password',
          passwordRep: 'Conferma Password',
          btn: {
            salva: 'Salva',
            annulla: 'Annulla'
          },
          msg: {
            insertData: 'Inserire tutti i dati',
            pwdMatch: 'Le password non coincidono'
          },
        }
      },
      fr_FR: {
        profilo: {
          titolo: 'Données de profil',
          mail: 'e-mail',
          domanda: 'Question secrète',
          risposta: 'Reponse secrète',
          password: 'Mot de passe',
          passwordOld: 'Ancien mot de passe',
          passwordNew: 'Nouveau mot de passe',
          passwordRep: 'Confirmer nouveau mot de passe',
          btn: {
            salva: 'Sauvegarder',
            annulla: 'Annuler'
          },
          msg: {
            insertData: 'Entrer toutes les données',
            pwdMatch: 'Les mots de passe ne correspondent pas'
          }
        }
      },
      es_ES: {
        profilo: {
          titolo: 'Datos de perfil',
          domanda: 'Pregunta Secreta',
          risposta: 'Respuesta Secreta',
          password: 'Contraseña',
          mail: 'Email',
          passwordOld: 'Antigua contraseña',
          passwordNew: 'Nueva contraseña',
          passwordRep: 'Confirmar contraseña',
          btn: {
            salva: 'Guardar',
            annulla: 'Anular'
          },
          msg: {
            insertData: 'Ingrese todos los datos',
            pwdMatch: 'Las contraseñas no coinciden'
          }
        }
      },
      de_DE: {
        profilo: {
          titolo: 'Profildaten',
          mail: 'E-Mail',
          domanda: 'Geheimfrage',
          risposta: 'Geheimantwort',
          password: 'Passwort',
          passwordOld: 'Altes Passwort',
          passwordNew: 'Neues Passwort',
          passwordRep: 'Passwort wiederholen',
          btn: {
            salva: 'Speichern',
            annulla: 'Stornieren'
          },
          msg: {
            insertData: 'Geben Sie alle Daten ein',
            pwdMatch: 'Passwörter stimmen nicht überein'
          }
        }
      },
      en_GB: {
        profilo: {
          titolo: 'Profile data',
          mail: 'e-mail',
          domanda: 'Domanda Segreta',
          risposta: 'Risposta Segreta',
          password: 'Password',
          passwordOld: 'Vecchia Password',
          passwordNew: 'Nuova Password',
          passwordRep: 'Conferma Password',
          btn: {
            salva: 'Salva',
            annulla: 'Annulla'
          },
          msg: {
            insertData: 'Enter all data',
            pwdMatch: 'Passwords do not match'
          }
        }
      }
    }
  },
  data() {
    return {
      tabActive: '1',
      loading: false,
      loadingBtnMail: false,
      loadingBtnQuest: false,
      loadingBtnPwd: false,
      showPrincipal: true,
      mailForm: {
        mail: '',
        pwd: ''
      },
      questionForm: {
        question: '',
        answer: '',
        pwd: ''
      },
      pwdForm: {
        oldPwd: '',
        newPwd: '',
        newPwdRep: ''
      },
      secretQuestions: [{
        value: 'q1'
      }, {
        value: 'q2'
      }, {
        value: 'q3'
      }, {
        value: 'q4'
      }, {
        value: 'q5'
      }, {
        value: 'q6'
      }, {
        value: 'q7'
      }, {
        value: 'q8'
      }]
    }
  },
  mounted: function () {
    this.mailForm.mail = this.$store.state.mail
  },
  methods: {
    changeMail: function () {
      this.loadingBtnMail = true
      var obj = {
        mail: this.mailForm.mail,
        pwd: this.mailForm.pwd
      }
      this.$http.post('dipendente/' + this.$store.state.country + '/changeMail', obj, { emulateJSON: true }).then(response => {
        if (response.body.rc === 0) {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'success'
          })
          this.$store.commit('set', { key: 'mail', value: this.mailForm.mail })
        } else {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'error'
          })
        }
        this.loadingBtnMail = false
      })
    },
    changeQuest: function () {
      this.loadingBtnQuest = true
      var obj = {
        question: this.questionForm.question,
        answer: this.questionForm.answer,
        pwd: this.questionForm.pwd
      }
      this.$http.post('dipendente/' + this.$store.state.country + '/changeQuest', obj, { emulateJSON: true }).then(response => {
        if (response.body.rc === 0) {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.body.msg[0].msgTxt,
            type: 'error'
          })
        }
        this.loadingBtnQuest = false
        this.$set(this, 'questionForm', {})
      })
    },
    changePwd: function () {
      let correctInput = true
      if (this.pwdForm.oldPwd === '' || this.pwdForm.newPwd === '' || this.pwdForm.newPwdRep === '') {
        correctInput = false
        this.$message({
          message: this.$i18n.t('profilo.msg.insertData'),
          type: 'error'
        })
      } else if (this.pwdForm.newPwd != this.pwdForm.newPwdRep) {
        correctInput = false
        this.$message({
          message: this.$i18n.t('profilo.msg.pwdMatch'),
          type: 'error'
        })
      }
      if (correctInput) {
        this.loadingBtnPwd = true
        var obj = {
          'oldPwd': this.pwdForm.oldPwd,
          'newPwd': this.pwdForm.newPwd,
          'newPwdRep': this.pwdForm.newPwdRep
        }
        this.$http.post('dipendente/' + this.$store.state.country + '/changePwd', ob, { emulateJSON: true }).then(response => {
          if (response.body.rc === 0) {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'success'
            })
          } else {
            this.$message({
              message: response.body.msg[0].msgTxt,
              type: 'error'
            })
          }
          this.loadingBtnPwd = false
          this.$set(this, 'pwdForm', {})
        })
      }
    },
    clearError: function () {
      this.isErrorMail = false
    },
    tabClick: function (tab, event) {
      if (this.tabActive !== this.tabActivePrev) {
        this.$set(this[this.tabActivePrev], 'swithModifica', false)
        this.tabActivePrev = this.tabActive
      }
    },
    openTab: function (tab) {
      this.$set(this, 'tabActive', tab)
    },
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-form_mobile.less";

.profilo {
  height: 100%;
  margin-left: 10px;
  margin-right: 10px;

  // padding: 10px;
  .profilo-title {
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
    height: 40px;
    text-align: center;
    margin-bottom: 20px;

    span {
      line-height: 40px;
      height: 40px;
      text-align: center;
      width: calc(100% - 50px);
      .set-font(@color: @rossoRiva, @size: 20px, @family: 'os-regular');
      font-weight: bold;
      letter-spacing: 2px;
      text-transform: uppercase;
      height: 40px;
      letter-spacing: 2px;
      padding-top: 10px;
    }
  }

  .menu-profilo {
    z-index: 100;
    background-color: #fff;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    color: @grayMedium;
    display: block;
    text-align: left;
    border-top: 1px solid @greyLine;

    //padding-top: 4px;
    //padding-bottom: 4px;
    .action {
      height: 60px;
      width: 33%;
      float: left;
      text-align: center;

      .box {
        height: 54px;
        margin-top: 3px;
        margin-bottom: 3px;

        .boxIcon {
          height: 30px;
          margin-bottom: 5px;
        }

        span {
          .set-font(@size: 8px, @color: @grayMedium);
          letter-spacing: 1px;
          line-height: 14px;
          display: block;

          &::first-line {
            line-height: 1;
          }
        }

        &.border-r {
          border-right: 1px solid @greyLine;
        }
      }

      &.selected {
        background-color: #f2fbfb;
        color: @greenRiva !important;

        span {
          color: @greenRiva !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Profilo/ProfiloMobile.vue